<template>
  <RouterView />
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue"
import { RouterView, useRoute } from "vue-router"
import { useCoachingStore } from "@/stores/coaching"
import { useUserStore } from "@/stores/user"

import { GlobalVariables } from "@/helpers/globalVariables"

const userStore = useUserStore()
const coachingStore = useCoachingStore()
const activeRoute = useRoute()

// COMPUTED
// Used as check for temporary fix to allow discovery CoachingUpsell page assign and keep Julie assigned to Executive users(caused by race condtition).
// We don't want to reassign coach on the confirmation page, so that the stripe payment event from the upsell has time to be processed and user updated to once.
const isCoachingConfirmationPage = computed(
  () => activeRoute.name === GlobalVariables.urls.coaching.children.confirmed.routeName
)

onMounted(async () => {
  await userStore.loadUserData()

  if (userStore.isTierFinishedOrHigher && !isCoachingConfirmationPage.value) {
    const promises = [coachingStore.loadCoaches(), coachingStore.loadAssignedCoach()]
    await Promise.all(promises)
  }
})
</script>
